export var isThisPlaylistSelectedForPlayer = function (playlistId, _a) {
    var currentPlayerTrackSource = _a.currentPlayerTrackSource;
    return Boolean(currentPlayerTrackSource &&
        currentPlayerTrackSource.type === "playlist" &&
        currentPlayerTrackSource.attributes.id === playlistId);
};
export var isThisPlaylistTrackSelectedForPlayer = function (_a, playerTrackQueueState) {
    var id = _a.id, trackIndex = _a.trackIndex;
    var currentPlayerTrackIndex = playerTrackQueueState.currentPlayerTrackIndex, currentPlayerTrackSource = playerTrackQueueState.currentPlayerTrackSource;
    if (!(currentPlayerTrackSource &&
        currentPlayerTrackSource.type === "playlist" &&
        currentPlayerTrackSource.attributes.id === id)) {
        return false;
    }
    return (currentPlayerTrackSource.attributes.id === id &&
        trackIndex === currentPlayerTrackIndex);
};
var x = function (_a) {
    var selected = _a.selected, audio = _a.audio;
};
export var selectPlayerRelation = {
    playlist: {
        private: function (_a) {
            var playlist = _a.playlist, track = _a.track, player = _a.player;
            return player.source.type === "playlist" &&
                player.source.attributes.id === playlist.id &&
                player.track.id === track.id;
        },
    },
};
